module.exports = {"main":{"type":"mini","content":[{"sub":"Overview","body":""}],"title":"main"},"maint":{"type":"mini","content":[{"sub":"Maintenance","body":""}],"title":"maint"},"equip":{"type":"mini","content":[{"sub":"Equipment","body":""}],"title":"equip"},"crp":{"type":"mini","content":[{"sub":"Contagion Risk Profile","body":""}],"title":"crp"}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/hoverTemplates/Card.json
// module id = 407
// module chunks = 1